/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: AbstractPrecompiledFactory.ts
 * Project: mle-client-n
 * Committed last: 2022/11/25 @ 119
 * ---
 * Description:
 */

import {HasName} from "../../../../../../common/utils";
import Pamela from "@revodigital/pamela";
import {ShapeTypes} from "../../../../../../common/enums";
import {IconName} from "@blueprintjs/core";

/**
 * Dati che ogni precompilato deve avere
 */
export interface PrecompiledBase extends HasName {
    fieldName: string;
    label: string;
    additionalGroups?: ShapeTypes[];
    iconName?: IconName;
}

export interface PrecompiledBaseInput {
    fieldName: string;
    label: string;
    additionalGroups?: ShapeTypes[];
}

/**
 * Factory generica per la generazione automatica di precompilati (forme che hanno al loro interno dei campi già collegati)
 */
export abstract class AbstractPrecompiledFactory<IndexType extends PrecompiledBase> {
    private _index: IndexType[] = [];

    protected constructor(index: IndexType[]) {
        this._index = index;
    }

    /**
     * Crea effettivamente la forma a partire dalle informazioni del precompilato
     * @param data Dati da utilizzare per creare la forma
     */
    abstract produce(data: IndexType): Pamela.Shape | undefined;

    /**
     * Crea una forma a partire dal suo nome
     * @param name
     */
    produceShape<T extends Pamela.Shape>(name: string): T {
        const data = this._index.filter(it => it.name === name);

        if (data.length > 1) throw new Error("Invalid precompiled index. More than one precompiled with the same name");
        if (data.length === 0) throw new Error(`Requested creation of undefined precompiled ${name}`)

        const s = this.produce(data[0]);
        if (!s) throw new Error(`Unable to create precompiled ${name}`);

        return s as T;
    }
}